import { EuiConfirmModal, EuiOverlayMask } from "@elastic/eui";
import React from "react";
import { FormattedMessage } from "react-intl";

function ConfirmationModal({ title, content, onConfirm, onCancel, confirmButtonText }) {
    return (
        <EuiOverlayMask>
            <EuiConfirmModal
                title={title}
                onCancel={onCancel}
                onConfirm={onConfirm}
                cancelButtonText={<FormattedMessage id="misc.cancel" />}
                confirmButtonText={confirmButtonText || <FormattedMessage id="misc.delete" />}
                buttonColor="danger"
            >
                {content}
            </EuiConfirmModal>
        </EuiOverlayMask>
    );
}

export default ConfirmationModal;
